
<template>
  <div class="top-title">{{ title }}</div>
</template>

<script>
export default {
  name: 'TopTitle',
  props: {
    title: String,
    sendData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
		
    }
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.top-title {
  padding: 32px 0 24px 0;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
</style>